import React, { useState, useRef } from "react";
import "./upload.css";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import * as qiniu from "qiniu-js";
import { getQiNiuUpToken } from "../../api";

const { Dragger, LIST_IGNORE } = Upload;

let subscription, video_id, video_url;

const QRCode = window.QRCode;

const Uploader = ({ token, removeToken }) => {
  const [disabled, setDisabled] = useState(false);

  const [fileList, setFileList] = useState([]);

  const [qrcodeSrc, setQrcodeSrc] = useState('');

  const qrcodeEl = useRef(null);

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    action: "",
    listType: "picture",
    disabled: disabled,
    fileList: fileList,

    showUploadList: {
      showDownloadIcon: true,
      downloadIcon: (file) => <img src={qrcodeSrc} alt="qrcode" width={200} height={200}></img>,
      showRemoveIcon: false,
    },

    beforeUpload(file) {
      const isMp4OrWebm =
        file.type === "video/mp4" || file.type === "video/webm";

      if (!isMp4OrWebm) {
        message.error("只能上传 MP4/WEBM 格式的视频文件!");
      }

      const isLt500M = file.size / 1024 / 1024 < 500;

      if (!isLt500M) {
        message.error("视频文件大小不能超过500M！");
      }

      return (isMp4OrWebm && isLt500M) || LIST_IGNORE;
    },

    onChange({ fileList: newFileList }) {
      setFileList(newFileList);
    },

    onStart(file) {
      setDisabled(true);
    },
    onSuccess(res, file) {
      setDisabled(false);
      setFileList((fileList) => {
        return [{ ...fileList[0], status: "done" }];
      });

      video_id = res?.result?.code;

      video_url = `http://share.kandaovr.com/${video_id}`;

      qrcodeEl.current.innerHTML = '';

      genQRCode(qrcodeEl.current, video_url);

      const qrcodeSrc = qrcodeEl.current.querySelector('canvas').toDataURL('image/png');
      setQrcodeSrc(qrcodeSrc);

      message.success(`${file.name} 文件上传成功，请扫描下方二维码获取视频分享链接。`);
    },
    onError(err, file) {
      setDisabled(false);
      setFileList((fileList) => {
        return [{ ...fileList[0], status: "error" }];
      });
      message.error(`${file.name} 文件上传失败，失败原因：${err}。`);
    },
    onProgress({ percent }, file) {
      setFileList((fileList) => {
        return [{ ...fileList[0], percent }];
      });
    },

    onPreview(file) {
      window.open(video_url);
    },

    onDownload(file) {
      const canvas = qrcodeEl.current.querySelector('canvas');
      downloadCanvasIamge(canvas, file.name.split('.')[0]);
    },

    customRequest({ file, filename, onError, onProgress, onSuccess }) {
      getQiNiuUpToken(token)
        .then((response) => response.json())
        .then((data) => {
          if (data?.code === 200) {
            let token = data?.result?.uptoken;

            const observer = {
              next(res) {
                onProgress({ percent: res.total.percent }, file);
              },
              error(err) {
                onError(err.message, file);
              },
              complete(res) {
                onSuccess(res, file);
              },
            };
            const observable = qiniu.upload(file, null, token);
            subscription = observable.subscribe(observer); // 上传开始
            console.log('subscription', subscription);
          } else {
            if (data?.code === 10003) {
              removeToken();
              message.error("登录超时，请重新登录！");
            } else {
              onError(data?.msg, file);
            }
          }
        })
        .catch((error) => {
          onError(error.message, file);
        });

      return {
        abort() {
          console.log("upload progress is aborted.");
        },
      };
    },

    onDrop(e) {
    },
  };

  function genQRCode(container, text) {
    new QRCode(container, {
      text: text,
      width: 300,
      height: 300,
      colorDark : "#000000",
      colorLight : "#ffffff",
      correctLevel : QRCode.CorrectLevel.H
    });
  }

  function downloadCanvasIamge(canvas, name) {
    var url = canvas.toDataURL('image/png')
    var a = document.createElement('a')
    var event = new MouseEvent('click')
    
    a.download = name || '自由视角分享二维码'
    a.href = url
    
    a.dispatchEvent(event)
  }

  return (
    <div className="up_container">
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">点击或拖拽文件到此区域来进行上传</p>
        <p className="ant-upload-hint">
          请上传Mp4、H264编码或Webm格式的视频，单个视频大小不能超过500M
        </p>
      </Dragger>
      <div ref={qrcodeEl} style={{display: 'none'}}></div>
    </div>
  );
};

export default Uploader;
